import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const contactWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.submit-contact-form', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

			let mid = $(this).data('mid');

			if (_this.isLoading) {
                return false;
            }

			$('.contact-form-msgs-holder').hide();
            $('#contact-form').find('.form-control').removeClass('is-invalid');
            $('#contact-form').find('.form-check-input').removeClass('is-invalid');

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

            var interested_in = $('input[name="contact_interested_in[]"]:checked').map(function() {
                return this.value;
            }).get().join(',');

			var values='';
            values+='module_id=' + mid;
            values+='&type=' + $(this).data('type');
            if ($('#contact_name_' + mid).length > 0) {
                values+='&name=' + $('#contact_name_' + mid).val();
            }
            if ($('#contact_email_' + mid).length > 0) {
                values+='&email=' + $('#contact_email_' + mid).val();
            }
            if ($('#contact_phone_' + mid).length > 0) {
                values+='&phone=' + $('#contact_phone_' + mid).val();
            }
            if ($('#contact_company_' + mid).length > 0) {
                values+='&company=' + $('#contact_company_' + mid).val();
            }
            if ($('#contact_position_' + mid).length > 0) {
                values+='&position=' + $('#contact_position_' + mid).val();
            }
            if ($('#contact_website_' + mid).length > 0) {
                values+='&website=' + $('#contact_website_' + mid).val();
            }
            if ($('#contact_message_' + mid).length > 0) {
                values+='&message=' + $('#contact_message_' + mid).val();
            }
            if ($('input[name="contact_interested_in[]"]').length > 0) {
                values+='&interested_in=' + interested_in;
            }
            if ($('#contact_type_of_involvement_' + mid).length > 0) {
                values+='&type_of_involvement=' + $('#contact_type_of_involvement_' + mid).val();
            }
            if ($('#contact_supported_program_' + mid).length > 0) {
                values+='&supported_program=' + $('#contact_supported_program_' + mid).val();
            }
            if ($('#contact_portfolio_' + mid).length > 0) {
                values+='&portfolio=' + $('#contact_portfolio_' + mid).val();
            }
            if ($('#contact_artistic_statement_' + mid).length > 0) {
                values+='&artistic_statement=' + $('#contact_artistic_statement_' + mid).val();
            }
            if ($('#contact_proposed_project_' + mid).length > 0) {
                values+='&proposed_project=' + $('#contact_proposed_project_' + mid).val();
            }
            //values+='&terms-and-condition=' + ($('#contact_terms-and-condition_' + mid).is(":checked")?1:'');
            if ($('#contact_privacy_' + mid).length > 0) {
                values+='&privacy=' + ($('#contact_privacy_' + mid).is(":checked")?1:'');
            }
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
                type: "POST",
                url: baseURL + '/contact/send',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 0) {
						var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#contact_' + errorKey + '_' + mid).addClass('is-invalid');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                            //$("#"+errorKey).closest('.form-group').addClass('has-error');
                            //$("#"+errorKey).css('border', '1px solid red');
                        }
                        //errorHtml
                        errorHtml;
                        $('#contact-form-error-msg').html(errorHtml);
                        $('#contact-form-error-msg').fadeIn();
                        $('#contact-form-error-msg').delay(10000).fadeOut();
                        //errors
                        return false;
                    }

					if (response.status == 1) {
						$('#contact_website_' + mid).val('');
						$('#contact_position_' + mid).val('');
						$('#contact_name_' + mid).val('');
                        $('#contact_email_' + mid).val('');
                        $('#contact_phone_' + mid).val('');
                        $('#contact_message_' + mid).val('');
						$('#contact_company_' + mid).val('');
						$('#contact_supported_program_' + mid).val('');
						$('#contact_type_of_involvement_' + mid).val('');
						$('#contact_portfolio_' + mid).val('');
						$('#contact_artistic_statement_' + mid).val('');
						$('#contact_proposed_project_' + mid).val('');
						//$('#contact_terms-and-condition_' + mid).prop('checked', false);
						$('#contact_privacy_' + mid).prop('checked', false);

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						if (cookies_advertisement == 1) {
							//gtag('event', 'conversion', {'send_to': ''});
						}

						if (cookies_advertisement == 1 || cookies_social == 1) {
							//fbq('track', 'Lead');
						}

						window.lintrk('track', { conversion_id: 9865345 });

						return false;
					}

					if (response.status == 2) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        $('#contact-form-error-msg').delay(10000).fadeOut();
                    }

					if (response.status == 3) {
						$('#contact-form-error-msg').html(response.errors);
                        $('#contact-form-error-msg').fadeIn();
                        $('#contact-form-error-msg').delay(10000).fadeOut();
                    }
                },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
            });
		}
    };

    if ($('.form-contact-home').length) {
        contactWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/contact.js